import { render } from "./AssetSchemeEditorView.vue?vue&type=template&id=4e588d46&scoped=true&ts=true"
import script from "./AssetSchemeEditorView.vue?vue&type=script&lang=ts"
export * from "./AssetSchemeEditorView.vue?vue&type=script&lang=ts"

import "./AssetSchemeEditorView.vue?vue&type=style&index=0&id=4e588d46&scoped=true&lang=scss"
import "@/assets/scss/asset-view-style.scss?vue&type=style&index=1&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e588d46"]])

export default __exports__